/* */
jQuery(document).ready(function ($) {
  'use strict'
  var $body = $('body'),
    // $site_wrap = $('.site-wrap'),
    $site_overlay = $('.site-overlay'),
    $mobile_menu = $('.main-menu--wrap')

  // === QUANTITY INPUT SPINNER ===
  // https://www.jqueryscript.net/form/Simple-Number-Spinner-with-jQuery-CSS3-Simple-Spinner.html
  $.fn.spinner = function () {
    this.each(function () {
      var el = $(this)

      if (el.hasClass('spinnered')) {
        return
      }

      // add elements
      if (el.hasClass('spinner-medium')) {
        el.wrap('<span class="spinner spinner-medium"></span>')
        el.removeClass('spinner-medium')
      } else {
        el.wrap('<span class="spinner"></span>')
      }

      el.before('<span class="sub">-</span>')
      el.after('<span class="add">+</span>')
      el.addClass('spinnered')

      // substract
      el.parent().on('click', '.sub', function () {
        var min = parseInt(el.attr('min')) > 0 ? parseInt(el.attr('min')) : 0
        if (el.val() > min) {
          el.val(function (i, val) {
            return --val
          })
          el.change()
        }
      })

      // increment
      el.parent().on('click', '.add', function () {
        var max = parseInt(el.attr('max')) > 0 ? parseInt(el.attr('max')) : 9999
        if (el.val() < max) {
          el.val(function (i, val) {
            return ++val
          })
          el.change()
        }
      })
    })
  }

  $('input[type=number]').spinner()
  $(document.body).on('updated_cart_totals', function () {
    // console.log('updated_cart_totals')
    $('input[type=number]').spinner()
  })

  //On add to cart
  $(document.body).on('added_to_cart', function () {
    console.log('added_to_cart')
    console.log($('.xoo-cp-qty'))
  })

  $(document).on('change', '.xoo-cp-qty', function (e) {
    var _this = $(this)
    var new_qty = parseFloat($(this).val())
    console.log(new_qty)
  })

  //----- Main menu hover
  $('.main-menu .menu-item-has-children').hover(
    function () {
      $('.menu-site-overlay').addClass('visible')
    },
    function () {
      $('.menu-site-overlay').removeClass('visible')
    }
  )

  //----- Mobile submenu toggle
  $('.mobile-menu-button').on('click', function (e) {
    $body.toggleClass('menu-in')
    $('.mobile-menu-button .btn').toggleClass('active')
    $mobile_menu.toggleClass('visible')
  })

  $site_overlay.on('click', function () {
    $body.toggleClass('menu-in')
    $('.mobile-menu-button .btn').toggleClass('active')
    $mobile_menu.toggleClass('visible')
  })

  $('.main-menu--wrap .sub-menu:visible').each(function () {
    $(this).before('<span class="submenu-trigger ion-android-remove"></span>')
  })
  $('.main-menu--wrap .sub-menu:hidden').each(function () {
    $(this).before('<span class="submenu-trigger ion-android-add"></span>')
  })

  $('.submenu-trigger').on('click', function () {
    $(this).next('.sub-menu').slideToggle()
    if ($(this).hasClass('ion-android-add')) {
      $(this).removeClass('ion-android-add').addClass('ion-android-remove')
    } else {
      $(this).removeClass('ion-android-remove').addClass('ion-android-add')
    }
  })

  // if($('.sticky-scroll-box').length){
  //     var top = $('.sticky-scroll-box').offset().top;
  //     $(window).scroll(function (event) {
  //         var y = $(this).scrollTop();
  //
  //         if (y >= top) {
  //           $('.sticky-scroll-box').addClass('fixed');
  //         } else {
  //           $('.sticky-scroll-box').removeClass('fixed');
  //         }
  //         $('.sticky-scroll-box').width($('.sticky-scroll-box').parent().width());
  //     });
  // }

  /*
   * Reference: http://jsfiddle.net/BB3JK/47/
   */

  $('select')
    .not('[name="shipping_nova_poshta_for_woocommerce_city"], [name="shipping_nova_poshta_for_woocommerce_warehouse"]')
    .not(
      '[name="billing_nova_poshta_region"], [name="billing_nova_poshta_city"], [name="billing_nova_poshta_warehouse"]'
    )
    .each(function () {
      var $this = $(this),
        numberOfOptions = $(this).children('option').length

      $this.addClass('select-hidden')
      $this.wrap('<div class="select"></div>')
      $this.after('<div class="select-styled"></div>')

      var $styledSelect = $this.next('div.select-styled')
      $styledSelect.text($this.children('option').eq(0).text())

      var $list = $('<ul />', {
        class: 'select-options'
      }).insertAfter($styledSelect)

      for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val()
        }).appendTo($list)
      }

      var $listItems = $list.children('li')

      $styledSelect.click(function (e) {
        e.stopPropagation()
        console.log('$styledSelect.click')

        $('div.select-styled.active')
          .not(this)
          .each(function () {
            $(this).removeClass('active').next('ul.select-options').hide()
          })

        $(this).toggleClass('active').next('ul.select-options').toggle()
      })

      $listItems.click(function (e) {
        e.stopPropagation()
        console.log('$listItems.click')

        $listItems.removeClass('selected')
        $(this).addClass('selected')
        $styledSelect.text($(this).text()).removeClass('active')
        $this.val($(this).attr('rel')).change()
        $list.hide()
      })

      $(document).click(function () {
        $styledSelect.removeClass('active')
        $list.hide()
      })
    })
})
